/*
<div class="trustpilot-widget" data-locale="en-GB" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="5bfc0324e795ae0001e5c982" data-style-height="20px" data-style-width="100%" data-theme="dark">

*/

import React from "react";
const PilotTopLeft = () => {
  // Create a reference to the <div> element which will represent the TrustBox
  const ref = React.useRef(null);
  React.useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);
  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="en-GB"
      data-template-id="5418052cfbfb950d88702476"
      data-businessunit-id="5bfc0324e795ae0001e5c982"
      data-style-height="30px"
      data-style-width="100%"
      data-theme="dark"
      data-stars="4,5"
      data-review-languages="en"
    >
      <a
        href="https://uk.trustpilot.com/review/www.jdmplates.co.uk"
        target="_blank"
        rel="noopener"
      >
        Trustpilot
      </a>
    </div>
  );
};
export default PilotTopLeft;
